import Axios from "../config/Axios";

export const ApiEditComidaDetalle = async (data) => {
 console.error("data para editar::::", data);
  try {
    const result = await Axios.post(`/POSTeditComidaDetalle`, data);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiCreateComidaDetalle = async (data) => {
  
  try {
    const result = await Axios.post(`/POSTcreateComidaDetalle`, data);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiDeleteComidaDetalle = async ({
  pre_detalle_comida_id,
}) => {
  const data = {
    pre_detalle_comida_id,
  };
  try {
    const result = await Axios.post(`/POSTdeleteComidaDetalle`, data);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};
  